import { css } from '@/styled-system/css';

export const panel = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'default',
  width: '100%',
  maxWidth: 'breakpoint-lg',
  marginInline: 'auto',
  paddingBlock: 'looser',
  paddingInline: 'default',
  color: 'text.neutral',
});

export const body = css({
  margin: 'zero',
});

export const actions = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 'loose',
});
